/* ============================================================
   UPPAbaby wishlist and baby registry.
   Generated by scripts/build_theme_registry.py. Do not edit here.
   ============================================================ */
(function () {
  'use strict';

  var API = 'https://marketing.coolkidz.com.au/api/registry';
  var K_WISH = 'ub_wishlist';
  var K_REG = 'ub_registry';

  /* ---------- storage ----------
     Every read and write is guarded. A private window, blocked site data or a
     browser with storage disabled all throw on access, and a saved list is
     never worth taking a page down for. */
  function read(k, fb) {
    try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? fb : v; }
    catch (e) { return fb; }
  }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- wishlist ----------
     Handles only. The list is hydrated from /products/<handle>.js when it is
     shown, so a price change, a new photo or a sold-out variant is never
     stale, and the stored list stays a few hundred bytes. */
  var wish = {
    all: function () { var a = read(K_WISH, []); return Array.isArray(a) ? a : []; },
    has: function (h) { return wish.all().indexOf(h) > -1; },
    count: function () { return wish.all().length; },
    toggle: function (h) {
      var a = wish.all(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.unshift(h);
      write(K_WISH, a.slice(0, 200));
      broadcast();
      return i === -1;
    },
    remove: function (h) {
      var a = wish.all(), i = a.indexOf(h);
      if (i > -1) { a.splice(i, 1); write(K_WISH, a); broadcast(); }
    }
  };

  function broadcast() {
    document.dispatchEvent(new CustomEvent('ub:wishlist', { detail: { count: wish.count() } }));
    paintAll();
    header();
  }

  /* The header link is rendered hidden and only appears once there is
     something in it, so a first time visitor is never offered a link to an
     empty page. */
  function header() {
    var link = document.querySelector('[data-saved-link]');
    if (!link) return;
    var n = wish.count();
    var wrap = link.querySelector('[data-saved-wrap]');
    if (wrap) wrap.hidden = n === 0; else link.hidden = n === 0;
    var span = link.querySelector('[data-saved-count]');
    if (span) span.textContent = n;
  }

  /* ---------- registry the browser knows about ---------- */
  var reg = {
    get: function () { var r = read(K_REG, null); return r && r.manageToken ? r : null; },
    set: function (r) { write(K_REG, r); },
    clear: function () { write(K_REG, null); }
  };

  /* ---------- the heart ---------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.2s-7.4-4.6-7.4-9.6a4.2 4.2 0 0 1 7.4-2.7 4.2 4.2 0 0 1 7.4 2.7c0 5-7.4 9.6-7.4 9.6z"/></svg>';

  function handleFrom(href) {
    if (!href) return null;
    var m = href.split('?')[0].match(/\/products\/([^\/#]+)/);
    return m ? m[1] : null;
  }

  function button(handle, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wish-btn' + (cls ? ' ' + cls : '');
    b.setAttribute('data-wish', handle);
    b.innerHTML = HEART;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = wish.toggle(handle);
      if (on) { b.classList.add('just'); setTimeout(function () { b.classList.remove('just'); }, 460); }
    });
    return b;
  }

  function paint(b) {
    var h = b.getAttribute('data-wish');
    // A decorative heart (the how-it-works tile) has no handle and no state.
    if (!h) return;
    var on = wish.has(h);
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', (on ? 'Saved: ' : 'Save ') + h.replace(/-/g, ' '));
    b.title = on ? 'Saved' : 'Save for later';
  }
  function paintAll() {
    [].forEach.call(document.querySelectorAll('.wish-btn'), paint);
  }

  /* Injected rather than written into the six templates that render a card.
     Absolutely positioned, so nothing moves when it appears. */
  function decorate(root) {
    [].forEach.call((root || document).querySelectorAll('.tile'), function (tile) {
      if (tile.querySelector('.wish-btn')) return;
      // The tile is usually a wrapper around a link; on the registry rail it
      // is the link.
      var a = tile.matches('a[href*="/products/"]') ? tile : tile.querySelector('a[href*="/products/"]');
      var h = handleFrom(a && a.getAttribute('href'));
      if (!h) return;
      tile.appendChild(button(h));
    });
    paintAll();
  }

  /* The PDP gets a labelled one in the buy column, under the button. */
  function decoratePdp() {
    var slot = document.querySelector('[data-wish-slot]');
    if (!slot || slot.querySelector('.wish-btn')) return;
    var h = slot.getAttribute('data-handle');
    if (!h) return;
    var line = document.createElement('div');
    line.className = 'wish-line';
    line.appendChild(button(h));
    var label = document.createElement('b');
    label.textContent = 'Save for later';
    line.appendChild(label);
    slot.appendChild(line);
    /* With a registry, the useful thing is a one click add. Without one, the
       useful thing is knowing a registry exists at all: it was a footer link
       and nothing else, which is no way to find it while you are standing on
       the pram you want someone else to buy (Mel, 25 Sep 2026). */
    var r = reg.get();
    var link = document.createElement('a');
    if (r) {
      link.href = '/pages/registry?manage=' + encodeURIComponent(r.manageToken) + '&add=' + encodeURIComponent(h);
      link.textContent = 'Add to my registry';
      link.setAttribute('data-add-registry', h);
    } else {
      link.href = '/pages/registry?from=' + encodeURIComponent(h);
      link.textContent = 'Add to a baby registry';
    }
    line.appendChild(link);
    paintAll();
  }

  /* ---------- product lookup ----------
     One in-memory cache per page view. The wishlist page asks for every saved
     handle at once and a registry owner adding items asks repeatedly. */
  var cache = {};
  function product(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  var money = function (cents) {
    if (cents == null) return '';
    var n = cents / 100;
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  /* ---------- API ---------- */
  function api(path, opts) {
    return fetch(API + path, Object.assign({ headers: { 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'Something went wrong' }; }); })
      .catch(function () { return { ok: false, error: 'Could not reach the registry. Check your connection.' }; });
  }

  /* Adds to the Shopify cart carrying the registry attribution. The leading
     underscore keeps both properties out of the cart, the checkout and the
     confirmation email. */
  function addGift(variantId, shareToken, itemId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variantId), quantity: qty || 1,
          properties: { _registry: shareToken, _registry_item: itemId }
        }]
      })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Could not add that'); }); });
  }

  /* ---------- boot ---------- */
  function boot() {
    decorate(document);
    decoratePdp();
    header();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Collections paginate and filter in place, so new tiles arrive after load.
  var mo = new MutationObserver(function () { decorate(document); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Saved on one tab, reflected on the next.
  addEventListener('storage', function (e) { if (e.key === K_WISH) { paintAll(); header(); } });

  window.UBReg = {
    wish: wish, reg: reg, api: api, product: product, money: money,
    addGift: addGift, paintAll: paintAll, button: button, handleFrom: handleFrom,
    decorate: decorate
  };
  // The page script is pulled in by the section, which sits earlier in the
  // document than this file. Two deferred scripts run in document order, so
  // the page script would otherwise look for UBReg before it existed and
  // quietly render nothing. It waits for this instead.
  document.dispatchEvent(new CustomEvent('ub:reg-ready'));
})();
